import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import "./style/headerstyle.css";
import Emc1Logo from "../image/orryx logo final.png";

const Header = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const [activePopup, setActivePopup] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  const [popupTimeout, setPopupTimeout] = useState(null);

  const showPopup = (popupKey, event) => {
    const rect = event.target.getBoundingClientRect();
    setActivePopup(popupKey);
    setPopupPosition({
      top: rect.bottom,
      left: rect.left + rect.width / 2 - 100 // Center horizontally
    });
    
    // Clear any existing timeout
    if (popupTimeout) {
      clearTimeout(popupTimeout);
      setPopupTimeout(null);
    }
    
    // Prevent event bubbling to parent elements
    event.stopPropagation();
  };


  const hidePopup = () => {
    // Add a longer delay before hiding the popup
    const timeout = setTimeout(() => {
      setActivePopup(null);
    }, 1500); // 1500ms delay
    setPopupTimeout(timeout);
  };



  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="header">
      <div className="logo-container">
        <Link to="/">
          <img src={Emc1Logo} alt="Emc Logo" className="logo-image" />
        </Link>
      </div>
      <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <Link
          to="/"
          onClick={toggleMenu}
          onMouseEnter={(e) => showPopup("home", e)}
          onMouseLeave={hidePopup}
        >
          Home
        </Link>
        <Link
          to="/about"
          onClick={toggleMenu}
          onMouseEnter={(e) => showPopup("about", e)}
          onMouseLeave={hidePopup}
        >
          About Us
        </Link>
        <Link
          to="/solution"
          onClick={toggleMenu}
          onMouseEnter={(e) => showPopup("solutions", e)}
          onMouseLeave={hidePopup}
        >
          Solutions
        </Link>
        {/* <Link
          to="/partners"
          onClick={toggleMenu}
          onMouseEnter={(e) => showPopup("partners", e)}
          onMouseLeave={hidePopup}
        >
          Partners
        </Link>
        <Link
          to="/customer"
          onClick={toggleMenu}
          onMouseEnter={(e) => showPopup("partners", e)}
          onMouseLeave={hidePopup}
        >
          Customer
        </Link> */}
        <Link
          to="/contact"
          onClick={toggleMenu}
          onMouseEnter={(e) => showPopup("contact", e)}
          onMouseLeave={hidePopup}
        >
          Contact Us
        </Link>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>

      {activePopup === "solutions" && (
        <div
          className="popup"
          style={{
            position: "fixed",
            top: popupPosition.top,
            left: popupPosition.left,
            zIndex: 1000,
            pointerEvents: 'auto'
          }}
          onMouseEnter={() => {
            if (popupTimeout) {
              clearTimeout(popupTimeout);
              setPopupTimeout(null);
            }
            setActivePopup("solutions"); // Ensure popup stays visible
          }}
          onMouseLeave={() => {
            // Only hide if mouse leaves both the link and popup
            setTimeout(hidePopup, 100);
          }}


        >


          <div className="popup-content">
            <ul className="solution-list">
              <li>
                <Link to="/solution/Networking-solution">
                  <span className="solution-title"><strong>Networking Solution</strong></span>
                </Link>
              </li>
              <li>
                <Link to="/solution/CyberSecurity-solution">
                  <span className="solution-title"><strong>CyberSecurity Solution</strong></span>
                </Link>
              </li>
              <li>
                <Link to="/solution/Infastructure-solution">
                  <span className="solution-title"><strong>Storage & Virtualization</strong></span>
                </Link>
              </li>
              <li>
                <Link to="/solution/Cloud-solution">
                  <span className="solution-title"><strong>Cloud Solution</strong></span>
                </Link>
              </li>
              <li>
                <Link to="/solution/Software-Solution">
                  <span className="solution-title"><strong>Software Solutions</strong></span>
                </Link>
              </li>
              <li>
                <Link to="/solution/AI&LOT">
                  <span className="solution-title"><strong>AI & IoT Solutions</strong></span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
